module.exports = __webpack_public_path__ + "static/media/descarga.151de70a.svg";